import {InjectionToken} from '@angular/core';
import {ShareResult} from '@capacitor/share';
import {Vault} from 'src/app/api/models/vault';

export interface LocalFileService {
    saveFile(content: ArrayBuffer, filename: string, openFile: boolean): Promise<void>;

    shareFile(content: ArrayBuffer, filename: string): Promise<void>;

    shareUrl(url: string): Promise<void | ShareResult>;

    createVaultDirectory(vault: Vault): Promise<void>;
}

export const LOCAL_FILE_SERVICE = new InjectionToken<LocalFileService>('LocalFileService');
